import { InputNumerico } from "app/components/inputs/InputNumerico"
import React from "react"
const estiloFormulario = require('../../../estilos/formulario.module.scss').default
const estiloTabela = require('../../../estilos/tabelas.module.scss').default
const estiloBotoes = require('../../../estilos/botoes.module.scss').default
import clsx from 'clsx'
import { useFormik } from "formik"
import globalMU from "globalMU"

export type EditarPrecoTintaEntrada = {
    Produto: string
    Cor: string
    PrecoUnitario:number
    DadosCorantes: {
        Codigo:string
        Nome: string
        Quantidade:number
    }[]
}

export type EditarPrecoTintaProps = {
    DadosEntrada: EditarPrecoTintaEntrada
    onPrecoAlterado: (preco:number) => void
}

export const EditarPrecoTinta = (props: EditarPrecoTintaProps) => {

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            PrecoUnitario: props.DadosEntrada.PrecoUnitario
        },
        onSubmit: () => {}
    })

    const produto = <>
        <label>
            Produto
        </label>
        <span className="_bg-white _p-2 _font-bold _w-full">
            {props.DadosEntrada.Produto}
        </span>
    </>

    const cor = <>
        <label>Cor</label>
        <span>
            {props.DadosEntrada.Cor}
        </span>
    </>

    const precoUnitario = <>
        <label>Preço Unitário</label>
        <InputNumerico
            id="PrecoUnitario"
            valor={formik.values.PrecoUnitario}
            onValorModificado={valor => formik.setFieldValue("PrecoUnitario",valor)}/>
    </>

    const tabelaCorantes = <>
        <table className={clsx(estiloTabela.tabela,"_w-full","_my-4")}>
            <thead>
                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome do Corante
                    </th>
                    <th>
                        Quantidade
                    </th>
                </tr>
            </thead>

            <tbody>
                {props.DadosEntrada.DadosCorantes.map(corante => <tr key={corante.Codigo}>
                    <td>
                        {corante.Codigo}
                    </td>
                    <td>
                        {corante.Nome}
                    </td>
                    <td className={estiloTabela.dadoNumerico}>
                        {globalMU.formatarValorNumerico(corante.Quantidade,3,false)}
                    </td>
                </tr>)}
            </tbody>
        </table>
    </>

    const botaoAplicar = <button 
        className={estiloBotoes.botaoPrimario}
        onClick={() => props.onPrecoAlterado(formik.values.PrecoUnitario)}>
        Aplicar
    </button>

    return <>
        <div className={estiloFormulario.formulario}>
            {produto}

            {cor}

            {precoUnitario}
        </div>

        {tabelaCorantes}

        {botaoAplicar}
    </>
}